import React from 'react'
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Breadcrumbs from '../../components/Breadcrumbs';

function CustomerCenter() {
    const page = "customercenter";
    return (
        <div>
            {/* <Header /> */}
            <section className={`hero ${page}`}>
                <h1>Customer-Centric Approach</h1>
            </section>

            <Breadcrumbs
                items={[
                    { label: "Home", to: "/" },
                    { label: "About", to: "/about" },
                    { label: "Customer-Center" }, // no `to` = current page
            ]}
            />

            <section className="section section--white">
            <div className="fullscreen-kicker">
                <h3>Putting Customers at the Heart of Everything We Do</h3>
            </div>
            <div className="container">
                <p>
                At <strong>DMCO</strong>, our customers are not just clients—they are long-term partners. Every decision we make, every process we refine, and every product we manufacture begins with a single 
                guiding principle: <strong>creating value for our customers</strong>.
                </p>
            </div>
            </section>

            <section className="section section--grey">
            <div className="fullscreen-kicker">
                <h3>Understanding Customer Needs</h3>
            </div>
            <div className="container">
                <p>
                We engage closely with our clients in the drilling and energy sectors to understand their challenges, whether it’s achieving higher efficiency, reducing downtime, or ensuring 
                reliability in the harshest environments. By listening, learning, and responding, we align our solutions to directly address these operational needs.
                </p>
            </div>
            </section>    

            <section className="section section--white">
            <div className="fullscreen-kicker">
                <h3>Tailored Solutions for Maximum Impact</h3>
            </div>
            <div className="container">
                <p>
                Our drilling materials are engineered not only to meet international standards, but to <strong>deliver measurable benefits in the field</strong>. Each batch is manufactured with precision, ensuring 
                consistency and performance that our customers can rely on in the most demanding drilling operations.
                </p>
            </div>
            </section>

            <section className="section section--grey">
            <div className="fullscreen-kicker">
                <h3>Long-Term Partnerships</h3>
            </div>
            <div className="container">
                <p>
                Customer satisfaction is not a one-time achievement for us—it is a continuous journey. We support our customers long after delivery through dedicated service, technical collaboration, 
                and process improvements. This partnership approach builds trust and ensures we grow together.
                </p>
            </div>
            </section>

            <section className="section section--white">
            <div className="fullscreen-kicker">
                <h3>Our Promise</h3>
            </div>
            <div className="container">
                <p>
                By combining our <strong>commitment to quality</strong>, our drive for <strong>innovation</strong>, and our focus on <strong>sustainability</strong>, DMCO's customer-centric approach ensures that every product and service we deliver helps our 
                customers achieve safer, more efficient, and more profitable drilling operations.
                </p>
            </div>
            </section>
            {/* <Footer /> */}
        </div>
    )
}

export default CustomerCenter